import {
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
} from '@mui/material'
import PageHelpButton from '../../components/PageHelpButton'
import { usePortalData } from '../../components/portal/PortalDataProvider'
import AttachmentsTab from '../../components/client-detail/AttachmentsTab'
import type { PortalSectionProps } from '../../components/portal/portalSection'

export default function PortalLinkedIn({ embedded }: PortalSectionProps = {}) {
  const { clientId } = usePortalData()

  return (
    <Box>
      {/* Suppressed when this renders as a tab of My Profile, which supplies
          the page heading. */}
      {!embedded && (
        <>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
            <Typography variant="h4" component="h1">
              LinkedIn
            </Typography>
            <PageHelpButton articleId="page-portal-linkedin" />
          </Stack>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your LinkedIn profile content and optimizations.
          </Typography>
        </>
      )}

      <Card>
        <CardContent>
          <AttachmentsTab
            entityId={clientId}
            entityType="linkedin"
            title="LinkedIn Content"
            emptyStateText="Your LinkedIn content will appear here once your strategist publishes it."
            hideUpload
          />
        </CardContent>
      </Card>
    </Box>
  )
}
